import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';
import { Spinner } from '../../components/Spinner/Spinner';
import { Pagination } from 'antd';

import api from '../../services/api';

import add_icon from '../../assets/general/plus_icon.svg';
import magnifying_icon from '../../assets/general/magnifying_icon.svg';
import anchor_icon from '../../assets/general/anchor_icon.svg';

import {
  Container,
  Content,
  PositionButton,
  PageTitle,
  SearchBox,
  SearchBoxContainer,
  Table,
  TableWrapper,
  TitleRow,
  Action,
} from './styles';
import { PaginationContainer } from '../../components/PaginationContainer';

interface Invoice {
  id: string;
  position: string;
  invoice_number: string;
  order_number: string;
  release_position: boolean;
  created_at: string;
  updated_at: string;
  user_id: string;
  position_occupied: boolean;
  pallets: {
    position: {
      position: string;
    }
  }[];

  user: {
    id: string;
    email: string;
    password: string;
    avatar: string;
    role_id: string;
    created_at: string;
    updated_at: string;
    individual_person: {
      id: string;
      name: string;
      phone_number: string;
      user_id: string;
      created_at: string;
      updated_at: string;
    };
  };
  invoice_positions: InvoicePosition[];
}

export interface InvoicePosition {
  id: string;
  invoice_id: string;
  position_id: string;
  is_occupied: boolean;
  position: Position;
  created_at: string;
  updated_at: string;
}

export interface Position {
  id: string;
  position: string;
  release_position: boolean;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export const ListPositions = () => {
  const [positions, setPositions] = useState<Invoice[]>();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchPositions, setSearchPositions] = useState('');
  const [loading, setLoading] = useState(false);

  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    getPositions();
  }, [currentPage]);

  const getPositions = async () => {
    setLoading(true);

    try {
      const response = await api.get('/invoices', {
        params: {
          page: currentPage,
          limit: '50',
        }
      });

      if (response) {
        const data = orderedPositions(response.data.results)

        setPositions(data);

        setTotal(response.data.total);
      }
    } catch (error: any) {
      handleError(error.response.data?.message || error.toString());
    } finally {
      setLoading(false);
    }
  };

  const handleError = (err: string) => {
    toast.error(err);
  };

  const orderedPositions = (positions: Invoice[]) => {
    const orderedPosition = positions.sort((a, b) => {
      if (a.position_occupied && !b.position_occupied) {
        return -1;
      }

      if (!a.position_occupied && b.position_occupied) {
        return 1;
      }

      return 0;
    });

    return orderedPosition;
  };

  const handleReleasePosition = async (id: string) => {
    setLoading(true);

    const data = {
      invoice_id: id,
    };

    try {
      const response = await api.post(`/invoices/positions/disassociate`, data);

      if (response) {
        toast.success('Posição liberada com sucesso!');
      }
    } catch (error: any) {
      handleError(error.response?.data?.message || error.toString());
    } finally {
      setLoading(false);
    }
  };

  // const renderPositions = (positions: InvoicePosition[]) => {
  //   return positions.map(({ position }, index) => {
  //     return (
  //       <p className="table_position" key={index}>
  //         {position && position.position}
  //       </p>
  //     );
  //   });
  // };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      getPosition();
    }
  };

  const getPosition = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/invoices?position=${searchPositions}`);

      if (response) {
        setPositions(orderedPositions(response.data.results));

        setTotal(response.data.total);
      }
    } catch (error: any) {
      handleError(error.response?.data?.message || error.toString());
    } finally {
      setLoading(false);
    }
  };

  const PaginationData = () => {
    return (
      <PaginationContainer>
        <Pagination
          defaultCurrent={currentPage}
          total={total}
          pageSize={50}
          onChange={(e: number) => setCurrentPage(e)}
          hideOnSinglePage
        />
      </PaginationContainer>
    );
  };

  return (
    <>
      <Header />

      <Sidebar />

      <Container>
        <Content>
          <TitleRow>
            <PageTitle>Armazém</PageTitle>

            <Link to="/adicionar-posicoes">
              <PositionButton>
                <img src={add_icon} alt="ícone de adicionar" />
                <span>Nova posição</span>
              </PositionButton>
            </Link>

            <SearchBoxContainer>
              <SearchBox
                placeholder="Buscar posições"
                value={searchPositions}
                onChange={(e) => setSearchPositions(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <img
                src={magnifying_icon}
                alt="ícone de procurar"
                onClick={() => getPosition()}
              />
            </SearchBoxContainer>
          </TitleRow>

          <TableWrapper>
            <Table>
              {!loading ? (
                <>
                  <thead>
                    <tr>
                      <th>Nota Fiscal</th>

                      <th>Pedido</th>

                      <th>Data</th>

                      <th>Usuário</th>

                      {/* <th>Ação</th> */}

                      <th>Posições</th>
                    </tr>
                  </thead>

                  <tbody>
                    {positions &&
                      positions.map(
                        ({
                          id,
                          position_occupied,
                          pallets,
                          invoice_number,
                          order_number,
                          created_at,
                          user,
                        }) => (
                          <tr key={id}>
                            <td data-label="Nota Fiscal">{invoice_number}</td>

                            <td data-label="Data">{order_number}</td>

                            <td data-label="Data">
                              {new Date(created_at).toLocaleDateString()}
                            </td>

                            <td data-label="Usuário">
                              {user?.individual_person?.name}
                            </td>

                            {/* <td data-label="Ação">
                              {position_occupied && (
                                <Action
                                  type="button"
                                  onClick={() => handleReleasePosition(id)}
                                >
                                  <img
                                    src={anchor_icon}
                                    alt="ícone de âncora"
                                  />
                                  Liberar
                                </Action>
                              )}
                            </td> */}

                            <td data-label="Posições">
                              {pallets?.length > 0 && pallets?.reduce((acc, item, index) => {
                                if(index === 0) {
                                  return item?.position?.position
                                }

                                if(index === pallets?.length - 1 && index !== 0) {
                                  return (acc + ' e ' + item?.position?.position)
                                }

                                return (acc + ', ' + item?.position?.position)
                                }, '')}
                            </td>
                          </tr>
                        ),
                      )}
                  </tbody>
                </>
              ) : (
                <div style={{ margin: '60px 0 60px 0' }}>
                  <Spinner />
                </div>
              )}
            </Table>
            {PaginationData()}
          </TableWrapper>
        </Content>
      </Container>
    </>
  );
};
